// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"xY","header":"xZ","description":"x0","cta":"x1"};